const loadAndRunCookieScript = (e) => {
    if (e)
        e.preventDefault();
    try {
        if (window.OneTrust &&
            typeof window.OneTrust.ToggleInfoDisplay === 'function') {
            window.OneTrust.ToggleInfoDisplay();
        }
        else if (window.Optanon &&
            typeof window.Optanon.TriggerConsentUI === 'function') {
            window.Optanon.TriggerConsentUI();
        }
        else {
            console.warn('Cookie preference center is not ready yet.');
        }
    }
    catch (err) {
        console.error('Failed to open cookie preference center:', err);
    }
};
export default loadAndRunCookieScript;
